import React from "react";
import Grid from "@mui/material/Grid2";
import { Box, colors } from "@mui/material";
import logo from "../../assets/Images/logo.png";
import visa from "../../assets/Images/landing/visa.webp";
import paypal from "../../assets/Images/landing/paypal.webp";
import skrill from "../../assets/Images/landing/skrill.webp";
import neteller from "../../assets/Images/landing/neteller.webp";
import master_card from "../../assets/Images/landing/master-card.webp";
import "./Footer.css";
import { Link } from "react-router-dom";
import YouTubeIcon from "@mui/icons-material/YouTube";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import TelegramIcon from "@mui/icons-material/Telegram";
import FacebookIcon from "@mui/icons-material/Facebook";
import playstore from "../../assets/Images/landing/play-store.svg";
import applestore from "../../assets/Images/landing/apple-store.svg";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";

const Footer = () => {
  return (
    <section className="footer-section">
      <div className="contain-width">
        <Box>
          <Grid container spacing={2} sx={{ alignItems: "center" }}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              className="mt-20"
            >
              <div class="footer-links">
                <Grid container spacing={3}>
                  <Grid item size={{ xs: 12, sm: 12, md: 3, lg: 4, xl: 4 }}>
                    <div class="footer-top">
                      <Link to={"/"}>
                        <div className="logo">
                          <img src={logo} alt="" />
                        </div>
                      </Link>
                      <p>
                        Empowering Traders Worldwide - Learn and Trade With
                        Finowiz. Reg No: 2024-00147
                      </p>
                    </div>

                    <div className="footer-cnt mt-20">
                      <p>Follow Us</p>
                      <div className="social-icons display-3">
                        <Link to="https://www.instagram.com/finowiz_official/">
                          <InstagramIcon />
                        </Link>
                        <Link to="https://x.com/FinowizOfficial">
                          <XIcon />
                        </Link>
                        <Link to="https://t.me/fxeducenter">
                          <TelegramIcon />
                        </Link>

                        <Link to="https://www.facebook.com/finowizfxofficial/">
                          <FacebookOutlinedIcon />
                        </Link>

                        <Link to="https://www.youtube.com/@finowizOfficial">
                          <YouTubeIcon />
                        </Link>
                      </div>
                    </div>
                  </Grid>

                  <Grid item size={{ xs: 6, sm: 6, md: 3, lg: 2, xl: 2 }}>
                    <div className="footer-cnt">
                      <p>Trade</p>
                      <List>
                        <ListItem>
                          <Link to="/">
                            <span>Home </span>
                          </Link>
                        </ListItem>
                        <ListItem>
                          <Link to="/instruments">
                            <span>Instruments</span>
                          </Link>
                        </ListItem>
                      </List>
                    </div>
                  </Grid>

                  <Grid item size={{ xs: 6, sm: 6, md: 3, lg: 2, xl: 2 }}>
                    <div className="footer-cnt">
                      <p>Partners</p>
                      <List>
                        <ListItem>
                          <Link to="/introduction-broker">
                            <span>Introducing Broker </span>
                          </Link>
                        </ListItem>
                        <ListItem>
                          <Link to="/pamm">
                            <span>PAMM </span>
                          </Link>
                        </ListItem>
                        <ListItem>
                          <Link to="/copy-trading">
                            <span>Copy Trading </span>
                          </Link>
                        </ListItem>
                      </List>
                    </div>
                  </Grid>

                  <Grid item size={{ xs: 6, sm: 6, md: 3, lg: 2, xl: 2 }}>
                    <div className="footer-cnt">
                      <p>Education</p>
                      <List>
                        <ListItem>
                          <Link to="/faq">
                            <span>FAQs </span>
                          </Link>
                        </ListItem>
                      </List>
                    </div>
                  </Grid>

                  <Grid item size={{ xs: 6, sm: 6, md: 3, lg: 2, xl: 2 }}>
                    <div className="footer-cnt">
                      <p>Company </p>
                      <List>
                        <ListItem>
                          <Link to="/about-us">
                            <span>About Us </span>
                          </Link>
                        </ListItem>
                        <ListItem>
                          <Link to="/contactus">
                            <span>Contact us </span>
                          </Link>
                        </ListItem>
                      </List>
                    </div>
                  </Grid>
                  <div className="risk-waring">
                    <h5 className="display-1">
                      <WarningRoundedIcon sx={{ color: "#E11A38" }} />
                      Risk Warning
                    </h5>
                    <p className="mt-10">
                      Risk Warning: Foreign exchange (Forex) and Contract for
                      Difference (CFD) online trading carries a high level of
                      risk and may not be suitable for all investors. Therefore,
                      please ensure that you have carefully considered your
                      investment objectives, level of experience, and risk
                      tolerance before attempting to trade Forex on Finowiz
                      Fintech Limited.
                    </p>
                    <p className="mt-10">
                      As with every investment, there is a possibility that you
                      could sustain a loss of some or all of your initial
                      investment. Therefore, you should not invest money that
                      you cannot afford to lose. You should be aware of all the
                      risks associated with Forex trading online, and seek
                      advice from an independent financial advisor if you have
                      any doubts.
                    </p>
                    <p className="mt-10">
                      Only invest in financial instruments if you know and
                      comprehend the risks associated with each financial
                      instrument. When using a financial instrument, you should
                      also recognize and accept that they run a high risk of
                      losses and damages. We do not guarantee the volume you can
                      trade with or the profits you can make with any portfolio
                      of instruments at any moment in time.
                    </p>
                    <p className="mt-10">
                      Finowiz Fintech Limited does not provide services for
                      citizens/residents of the India,United States, Cuba, Iraq,
                      Myanmar, North Korea & Sudan. The services of Finowiz
                      Fintech Limited are not intended for distribution to, or
                      use by, any person in any country or jurisdiction where
                      such distribution or use would be contrary to local law or
                      regulation.
                    </p>
                  </div>
                </Grid>
              </div>
              <div class="footer-bottom mb-10">
                <p>
                  Copyright @ 2025 Finowiz Fintech Limited I All Rights Reserved
                </p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </section>
  );
};

export default Footer;
